import './styles/tokens.css';
import './styles/base.css';
import './styles/boot.css';
import './styles/hud.css';
import './styles/menu.css';
import './styles/panels.css';

import { mountApp } from './ui/app.js';

/**
 * Point d'entree.
 *
 * Aucun travail reseau ici : `mountApp` orchestre la sequence Discord ->
 * session -> profil, et affiche un ecran de boot honnete pendant ce temps.
 */

const host = document.getElementById('app');

if (host instanceof HTMLElement) {
  mountApp(host);
} else {
  // Ne devrait jamais arriver : index.html fournit #app.
  document.body.append('Conteneur #app introuvable.');
}
